        <!-- DataRecords 协议卡采集记录 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="dataRecords">
      <div class="dataRecords_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>协议卡采集记录</h1>
      <div class="dataRecords_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>

    <!-- 查询条件 -->
    <div class="dataRecords_query">
      <div class="query_list clearfix fl">
        <span class="fl">归属机构：</span>
        <el-cascader
          class="fl"
          :clearable="true"
          v-model="value"
          :checkStrictly="true"
          :options="options"
          placeholder="系统管理机构"
          filterable
          :props="{ expandTrigger: 'hover', checkStrictly: true }"
          @change="handleChange"
        ></el-cascader>
      </div>

      <div class="query_list clearfix fl">
        <span class="fl">采集点：</span>
        <el-select v-model="deviceId" clearable placeholder="请选择">
          <el-option
            v-for="item in deviceList"
            :key="item.value"
            :label="item.deviceName"
            :value="item.deviceId"
          >
          </el-option>
        </el-select>
      </div>

      <div class="query_list clearfix fl">
        <span class="fl">记录日期：</span>
        <el-date-picker
          v-model="dateTime"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          :start-placeholder="beginDate"
          :end-placeholder="endDate"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
      <el-button type="primary" @click="queryClick()" icon="el-icon-search">
        查询
      </el-button>
      <el-button type="success" @click="exportClick()" icon="el-icon-upload2"
        >导出</el-button
      >
    </div>

    <!-- 数据展示 -->
    <div class="dataRecords_content">
      <div class="dataRecords_title clearfix">
        <p
          class="fl"
          :style="{
            width:
              index == 0 || index == nameToDescList.length - 1
                ? '200px'
                : 'calc((100% - 400px) / ' + (nameToDescList.length - 2) + ')',
          }"
          v-for="(item, index) in nameToDescList"
          :key="index"
        >
          {{ item.value }}
        </p>
      </div>

      <div v-show="HJ212RecordsList.length > 0">
        <div
          class="dataRecords_list"
          v-for="(item, index) in HJ212RecordsList"
          :key="index"
        >
          <p
            class="fl"
            :style="{
              width:
                i == 0 || i == nameToDescList.length - 1
                  ? '200px'
                  : 'calc((100% - 400px) / ' +
                    (nameToDescList.length - 2) +
                    ')',
            }"
            v-for="(val, i) in nameToDescList"
            :title="item[val.keys]"
            :key="i"
          >
            {{ item[val.keys] }}
          </p>
        </div>
        <div class="dataRecords_btn">
          <span>共{{ total }}条数据</span>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="total"
            background
          >
          </el-pagination>
        </div>
      </div>

      <div v-show="HJ212RecordsList.length == 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

    <div class="pos" v-show="isLogin">
      <i class="el-icon-loading"></i>
    </div>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
import { JSONToExcelConvertor } from "../../assets/js/excel";
export default {
  data() {
    return {
      isLogin:false,
      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",

      // 机构树
      options: [],
      // 当前选择机构
      value: [],
      // 当前机构ID
      deptId: "",

      // 采集点LIST
      deviceList: [],
      // 当前采集点ID
      deviceId: "",

      // 快捷选择日期LIST
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // 记录日期
      dateTime: "",

      // 当前页数
      page: 1,
      // 总数据数
      total: 0,

      // 开始日期
      beginDate: "2021-12-15",
      // 结束日期
      endDate: "2021-12-15",

      // HJ212报表数据Title
      nameToDescList: [
        {
          keys: "ST",
          value: "ST",
        },
        {
          keys: "CN",
          value: "CN",
        },
        {
          keys: "DataTime",
          value: "记录时间",
        },
      ],
      // HJ212报表数据List
      HJ212RecordsList: [],
      // 查询条件
      queryList: {
        deptId: "",
        deviceId: "",
        beginDate: "",
        endDate: "",
        page: 1,
      },
    };
  },
  created() {
    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);

    // 获取星期
    let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }

    // 获取机构树
    this.options = JSON.parse(localStorage.getItem("structure"));

    let time = new Date();
    let n = time.getFullYear();
    let y =
      time.getMonth() + 1 > 9
        ? time.getMonth() + 1
        : "0" + (time.getMonth() + 1);
    let r = time.getDate() > 9 ? time.getDate() : "0" + time.getDate();

    this.beginDate = n + "-" + y + "-" + r;
    this.endDate = n + "-" + y + "-" + r;

    let nameToDescList = JSON.parse(localStorage.getItem("dataItems"));
    nameToDescList.push({
      dataId: "",
      keys: "drDate",
      value: "记录时间",
    });
    nameToDescList.unshift({
      dataId: "",
      keys: "deviceName",
      value: "采集点",
    });
    this.nameToDescList = nameToDescList;
  },
  methods: {
    // 导出数据
    exportClick() {
      if (this.HJ212RecordsList.length > 0) {
        let loginToken = localStorage.getItem("loginToken");
        var jo = {
          txcode: "DataRecords",
          option: "DOWNLOAD",
          deptId: this.queryList.deptId,
          deviceId: this.queryList.deviceId,
          beginDate: this.queryList.beginDate,
          endDate: this.queryList.endDate,
          loginToken: loginToken,
        };
        let url = this.api;
        url = url.replace("/DipoJson.cgi", "/DipoView.cgi"); //导出时需要把DipoJson换成DipoView
        var form = $("<form id='tempform' name='tempform'></form>")
          .attr("action", url)
          .attr("method", "post")
          // .attr("target", "rfFrame");
          .attr("target", "footframe");
        for (var key in jo) {
          form.append(
            $("<input></input>")
              .attr("type", "hidden")
              .attr("name", key)
              .attr("value", jo[key])
          );
        }
        form.appendTo("body").submit().remove();

        // let timeDate = new Date();
        // let n = timeDate.getFullYear();
        // let y =
        //   timeDate.getMonth() + 1 > 9
        //     ? timeDate.getMonth() + 1
        //     : "0" + (timeDate.getMonth() + 1);
        // let r =
        //   timeDate.getDate() > 9
        //     ? timeDate.getDate()
        //     : "0" + timeDate.getDate();
        // let s =
        //   timeDate.getHours() > 9
        //     ? timeDate.getHours()
        //     : "0" + timeDate.getHours();
        // let f =
        //   timeDate.getMinutes() > 9
        //     ? timeDate.getMinutes()
        //     : "0" + timeDate.getMinutes();
        // let m =
        //   timeDate.getSeconds() > 9
        //     ? timeDate.getSeconds()
        //     : "0" + timeDate.getSeconds();

        // let textName = "协议卡采集记录_" + n + y + r + s + f + m;

        // var values = "";
        // for (let i = 0; i < this.patchLists.length; i++) {
        //   if (this.patchLists[i].deviceId == this.deviceId) {
        //     values = this.patchLists[i].deviceName;
        //     break;
        //   }
        // }
        // JSONToExcelConvertor(
        //   values,
        //   this.dataItems,
        //   this.HJ212RecordsList,
        //   textName
        // );
      } else {
        this.$message({
          message: "暂无数据！",
          type: "warning",
        });
      }
    },
    // 查询数据
    queryClick() {
      this.isLogin = true;
      // if (this.deviceId !== "") {
      if (this.dateTime !== "" && this.dateTime !== null) {
        let n1 = this.dateTime[0].getFullYear();
        let y1 =
          this.dateTime[0].getMonth() + 1 > 9
            ? this.dateTime[0].getMonth() + 1
            : "0" + (this.dateTime[0].getMonth() + 1);
        let r1 =
          this.dateTime[0].getDate() > 9
            ? this.dateTime[0].getDate()
            : "0" + this.dateTime[0].getDate();

        let n2 = this.dateTime[1].getFullYear();
        let y2 =
          this.dateTime[1].getMonth() + 1 > 9
            ? this.dateTime[1].getMonth() + 1
            : "0" + (this.dateTime[1].getMonth() + 1);
        let r2 =
          this.dateTime[1].getDate() > 9
            ? this.dateTime[1].getDate()
            : "0" + this.dateTime[1].getDate();

        this.beginDate = n1 + "-" + y1 + "-" + r1;
        this.endDate = n2 + "-" + y2 + "-" + r2;

        this.queryList.deptId = this.deptId;
        this.queryList.deviceId = this.deviceId;
        this.queryList.beginDate = this.beginDate;
        this.queryList.endDate = this.endDate;
        this.queryList.page = 1;

        this.page = 1;

        this.RecordsLists(this.queryList);
      } else {
        this.queryList.deptId = this.deptId;
        this.queryList.deviceId = this.deviceId;
        this.queryList.beginDate = this.beginDate;
        this.queryList.endDate = this.endDate;
        this.queryList.page = 1;

        this.page = 1;

        this.RecordsLists(this.queryList);
      }
      // } else {
      //   this.$message({
      //     message: "查询内容不能为空!",
      //     type: "warning",
      //   });
      // }
    },

    // 现在所属机构
    handleChange(value) {
      this.deviceId = "";
      let val = JSON.parse(JSON.stringify(value));
      if (val.length >= 1) {
        this.deptId = val[val.length - 1];
      } else {
        this.deptId = "";
      }
      // 获取采集点
      this.HJ212Records(this.deptId);
    }, // 获取机构下的采集点
    HJ212Records(deptId) {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DataRecords",
          deptId,
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            if (res.data.devices.length > 0) {
              this.deviceList = res.data.devices;
            }
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 选择跳转分页
    handleCurrentChange(val) {
      this.isLogin = true;
      this.queryList.page = val;
      // 调用采集点监控
      this.RecordsLists(this.queryList);
    },
    // 获取采集点的报表数据
    RecordsLists(queryList) {
      console.log(queryList);
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DataRecords",
          option: "LIST",
          deptId: queryList.deptId,
          deviceId: queryList.deviceId,
          beginDate: queryList.beginDate,
          endDate: queryList.endDate,
          page: queryList.page,
          loginToken,
        },
      })
        .then((res) => {
          this.isLogin = false;
          console.log(res, "sss");
          if (res.data._STATUS == 0) {
            if (res.data.list.length > 0) {
              // 总数
              this.total = res.data.rowsCount;
              // 报表数据
              let HJ212RecordsList = res.data.list;

              for (let i = 0; i < HJ212RecordsList.length; i++) {
                HJ212RecordsList[i].drDate =
                  res.data.list[i].drDate + " " + res.data.list[i].drTime;
              }
              this.HJ212RecordsList = HJ212RecordsList;

              this.$message({
                message: "查询成功",
                type: "success",
              });
              // let nameToDesc = res.data.nameToDesc;
              // let nameToDescList = [];
              // for (var key in nameToDesc) {
              //   let arr = {
              //     keys: key,
              //     value: nameToDesc[key],
              //     width: "",
              //   };
              //   nameToDescList.push(arr);
              // }
              // let num = 0;
              // let index = "";
              // for (let i = 0; i < nameToDescList.length; i++) {
              //   if (nameToDescList[i].key == "data_time") {
              //     num++;
              //     index = i;
              //     break;
              //   }
              // }
              // if (num > 0) {
              //   nameToDescList[index].value = "记录时间";
              // } else {
              //   nameToDescList.push({
              //     keys: "data_time",
              //     value: "记录时间",
              //     width: "",
              //   });
              // }
              // this.nameToDescList = nameToDescList;
              // for (let j = 0; j < this.nameToDescList.length; j++) {
              //   this.nameToDescList[j].width =
              //     (document.documentElement.clientWidth - 220) /
              //       this.nameToDescList.length -
              //     1;
              // }
            } else {
              this.HJ212RecordsList = [];
              this.$message({
                message: "暂无数据！",
                type: "warning",
              });
            }
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
// 表头
.dataRecords {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .dataRecords_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .dataRecords_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

// 查询条件
.dataRecords_query {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
  .query_list {
    height: 46px;
    line-height: 40px;
    margin-right: 20px;
  }
}

// 数据展示
.dataRecords_content {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
  .dataRecords_title {
    width: 100%;
    text-align: center;
    color: #fff;
    height: 40px;
    line-height: 40px;
    background-color: #545c64;
    .sg {
      width: 200px;
    }
  }
  .dataRecords_list {
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    p {
      height: 40px;
      padding: 0 5px;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &:nth-child(2n-1) {
      background-color: #f0faff;
    }
    &:hover {
      cursor: pointer;
      background-color: rgb(253, 246, 238);
    }
  }
  .dataRecords_btn {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      margin: 0 20px;
      color: #666666;
    }
  }
}

.pos{
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  z-index: 9999;
  height: calc(100% - 50px);
  background-color: rgba(0,0,0,.5);
  i{
    position: absolute;
    top: 40%;
    left: calc(50% - 30px);
    font-size: 50px;
    color: #fff;
  }
}
</style>